type MaterialWithName = Readonly<{ name?: unknown }> | null | undefined;

/** Estrecha `material.name` a texto; el vacío lo descarta `Dialog`, que entonces usa su título visible. */
export function getMaterialAccessibleName(material: MaterialWithName): string | undefined {
  const name = material?.name;
  return typeof name === 'string' ? name : undefined;
}
